import { Box, Button, LinearProgress, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { Activity } from "./Activity";
import { MyListApi } from "../utils/restApi";
import { useDispatch } from "react-redux";
import { addNotification } from "../slices/notificationSlice";

const PER_PAGE = 10;

export const UserActivities = ({ userId }) => {

    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [maxPages, setMaxPages] = useState(0);
    const [loading, setLoading] = useState(true);
    const [activities, setActivities] = useState([]);

    // Start over when the profile changes.
    useEffect(() => {
        setActivities([]);
        setPage(0);
        setMaxPages(0);
    }, [userId]);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        MyListApi.getActivities(page, PER_PAGE, userId)
            .then(data => {
                if (cancelled) return;
                setActivities(prev => page === 0 ? data.items : [...prev, ...data.items]);
                setMaxPages(data.maxPageCount || 0);
            })
            .catch (error => {
                if (cancelled) return;
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => { cancelled = true; };
    }, [userId, page, dispatch]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {activities.map((a, ix) => <Activity activity={a} key={a.id || ix} />)}
            {loading ? <LinearProgress aria-label="Loading activity" /> : null}
            {!loading && activities.length === 0 ? <Typography color="text.secondary">No recent activity.</Typography> : null}
            {!loading && page < maxPages - 1 ? <Button variant="outlined" onClick={() => setPage(p => p + 1)}>Show more</Button> : null}
        </Box>
    );
}
